<template>
  <v-dialog v-model="dialog" max-width="700">
    <template v-slot:activator="{ on }" v-if="!no_icon">
      <v-btn icon color="grey" v-on="on"><v-icon>mdi-pencil</v-icon></v-btn>
    </template>
    <v-card>
      <v-card-title class="grey--text text-subtitle-1">
        Modifica Quantità
      </v-card-title>
      <v-card-text>
        <v-row class="mb-1">
          <v-col cols="12">
            <span style="font-size: 20px"> {{ nome[0] }}</span>
            <br />
            <span style="font-size: 12px"> {{ nome[1] }}</span>
          </v-col>
        </v-row>
        <template v-if="prodotto_obj.specie">
          <template v-for="serie in gruppo_serie">
            <v-row :key="serie.id_series" no-gutters class="py-1 pl-1">
              <span>{{
                serie.id_series
                  ? get_serie(serie.id_series).nome
                  : "Nessuna Serie"
              }}</span>
            </v-row>
            <AggiungiColoreSpecie
              v-for="colore in serie.colori"
              :key="colore.id"
              :colore="colore"
              :prodotto="prodotto"
              :ordine="ordine"
              :nome_serie="
                get_serie(serie.id_series)
                  ? get_serie(serie.id_series).nome
                  : ''
              "
            />
          </template>
        </template>

        <v-row v-else>
          <v-col
            :cols="$vuetify.breakpoint.mobile ? 3 : 2"
            v-for="colore in prodotto_obj.colori"
            :key="colore.id"
          >
            <AggiungiColore
              :colore="colore"
              :prodotto="prodotto"
              :ordine="ordine"
            />
          </v-col>
        </v-row>
        <v-row class="mt-4">
          <v-col>
            <v-text-field
              outlined
              hide-details
              v-model="commento"
              label="Commento"
            >
              <template v-slot:append>
                <v-slide-x-reverse-transition mode="out-in">
                  <v-progress-circular
                    indeterminate
                    color="grey"
                    width="1"
                    size="20"
                    v-if="loading_commento"
                  />
                  <v-icon color="success" v-if="commento_ok">mdi-check</v-icon>
                </v-slide-x-reverse-transition>
              </template>
            </v-text-field>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text color="grey" @click="dialog = false">chiudi</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AggiungiColore from "./ordine_aggiungi_colore.vue";
import AggiungiColoreSpecie from "./ordine_aggiungi_colore_specie.vue";
import _ from "lodash";
export default {
  components: {
    AggiungiColore,
    AggiungiColoreSpecie,
  },
  props: {
    prodotto: String,
    ordine: Object,
    no_icon: Boolean,
  },
  created() {
    this.debouncecmt = _.debounce(this.send_commento, 1200);
  },
  mounted() {
    if (this.prodotto_obj.specie) {
      this.fetchAllColors();
    }
  },
  data() {
    return {
      dialog: false,
      cmt_to_send: "",
      loading_commento: false,
      commento_ok: false,
      colori: [],
    };
  },
  watch: {
    dialog: function () {
      if (!this.dialog) {
        this.$emit("close");
      }
    },
  },
  computed: {
    prodotto_obj() {
      return this.$store.getters.get_prodotto_by_id(this.prodotto);
    },
    nome() {
      return this.prodotto_obj.nome.split(" in ");
    },

    commento: {
      get() {
        return this.ordine.articoli.find((art) => art.art == this.prodotto)
          .commento;
      },
      set(cmt) {
        this.cmt_to_send = cmt;
        this.debouncecmt();
      },
    },
    specie() {
      return this.$store.getters.get_specie_by_id(this.prodotto_obj.specie);
    },
    gruppo_serie() {
      const result = this.colori
        .filter(
          (colore) =>
            this.prodotto_obj.series.includes(colore.id_series[0]) ||
            (this.prodotto_obj.series.includes("000000") &&
              colore.id_series.length == 0)
        )
        .reduce((acc, obj) => {
          // Se l'array id_series è vuoto, aggiungi il prodotto sotto null
          if (obj.id_series.length === 0) {
            if (!acc[null]) {
              acc[null] = [];
            }
            acc[null].push(obj);
          } else {
            // Altrimenti, iteriamo su id_series e aggiungiamo il prodotto ai rispettivi id_series
            obj.id_series.forEach((id_series) => {
              if (!acc[id_series]) {
                acc[id_series] = [];
              }
              acc[id_series].push(obj);
            });
          }
          return acc;
        }, {});

      const finalArray = Object.entries(result).map(([key, value]) => ({
        id_series: key !== "null" ? key : null, // Converti 'null' in vero null
        colori: value,
      }));
      finalArray.sort((a, b) => {
        if (a.id_series === null) return -1;
        if (b.id_series === null) return 1;
        return 0; // Lascia invariato l'ordine per gli altri elementi
      });
      return finalArray;
    },
  },
  methods: {
    open() {
      this.dialog = true;
    },
    send_commento() {
      this.loading_commento = true;
      this.$store
        .dispatch("modifica_commento", {
          ordine: this.ordine._id.$oid,
          id_prodotto: this.prodotto,
          commento: this.cmt_to_send,
        })
        .then(() => {
          this.loading_commento = false;
          this.commento_ok = true;
          setTimeout(() => {
            this.commento_ok = false;
          }, 1500);
        });
    },
    async fetchAllColors() {
      this.colori = await this.$store.dispatch(
        "fetch_colori_by_id",
        this.specie.colori
      );
    },
    get_serie(id_serie) {
      return this.specie.series.find((serie) => serie.id == id_serie);
    },
  },
};
</script>